import { createApp, nextTick } from 'vue';
import App from './App.vue';
import router from './router';

import '@/assets/css/bootstrap.min.css';
import '@/assets/css/bootstrap-overrides.css';
import '@/assets/css/style.css';
import '@/assets/css/dashboard-icons.css';

let app = createApp(App).use(router);

//===============================================
// Mixins

import AjaxMixin from './mixins/AjaxMixin';
import WindowDimensionsMixin from './mixins/WindowDimensionsMixin';
app.mixin(AjaxMixin);
app.mixin(WindowDimensionsMixin);

//===============================================
// Config environment (dev vs prod)

let apiRoot = null;
let environment = null;
console.log(window.location.hostname);

if (window.location.hostname == 'localhost') {
    apiRoot = process.env.VUE_APP_API_URL_DEV;
    environment = 'development';
} else if (
    window.location.hostname == 'beta.app.ipacdashboard.com' ||
    window.location.origin == process.env.VUE_APP_URL_BETA
) {
    apiRoot = process.env.VUE_APP_API_URL_BETA;
    environment = 'beta';
} else if (
    window.location.hostname == 'app.ipacdashboard.com' ||
    window.location.origin == process.env.VUE_APP_URL_PROD
) {
    apiRoot = process.env.VUE_APP_API_URL_PROD;
    environment = 'production';
}

app.config.globalProperties.$env = {
    apiRoot: apiRoot,
    environment: environment,
};

//===============================================
// Stores

import { createPinia } from 'pinia';
import { useUserStore } from './stores/user';
import { usePermissionStore } from './stores/permission';
import { useAlertStore } from './stores/alert';
import { useEmployeesStore } from './stores/employees';
import { useSiteStore } from './stores/site';
import { useRoleStore } from './stores/role';

// Make frequently-used "user" store global for ease of access
let pinea = createPinia();
app.use(pinea);

app.config.globalProperties.$alertStore = useAlertStore();

const userStore = useUserStore();
app.config.globalProperties.$userStore = userStore;

const permissionStore = usePermissionStore();
app.config.globalProperties.$permStore = permissionStore;

const employeesStore = useEmployeesStore();
app.config.globalProperties.$employeesStore = employeesStore;

const siteStore = useSiteStore();
app.config.globalProperties.$siteStore = siteStore;

const roleStore = useRoleStore();
app.config.globalProperties.$roleStore = roleStore;

nextTick(() => {
    userStore.sync();
});

app.mount('#app');
export default app;
